import firebase from "firebase/app";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAIHaNGpOUz2q_YlVZhTQc__TF_ZXubcS0",
  authDomain: "bgn-heroes.firebaseapp.com",
  databaseURL: "https://bgn-heroes.firebaseio.com",
  projectId: "bgn-heroes",
  storageBucket: "bgn-heroes.appspot.com",
  messagingSenderId: "188723228938",
  appId: "1:188723228938:web:9e6f4d789160a9410f4af3",
  measurementId: "G-TC465ET61Z"
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
